<div #backdrop class="drawer-backdrop" (click)="_onBackdropClicked()"></div>
<ng-content select="sim-sidenav" />
<ng-content select="sim-sidenav-content" />
